import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PlayerProfile } from '@shared/types';
import { MMR_START } from '@shared/gameConfig';

interface UserState {
  profile: PlayerProfile;
  pb: number | null;
  setProfile: (p: Partial<PlayerProfile>) => void;
  setPb: (pb: number) => void;
  reset: () => void;
}

const DEFAULT_PROFILE: PlayerProfile = {
  id: 'guest-local',
  name: 'V.MINH',
  avatarColor: 'red',
  avatarUrl: null,
  mmr: 1287,
  mmrSolo: 1287,
  mmrDuo: 1287,
  rank: 'bronze',
  rankDivision: 4,
  rankStars: 0,
  rankDuo: 'bronze',
  rankDivisionDuo: 4,
  rankStarsDuo: 0,
  coins: 2840,
  gems: 18,
  xp: 0,
  winStreak: 0,
  streakSolo: 0,
  streakDuo: 0,
  matchesPlayed: 0,
  matchesWon: 0,
};

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      profile: DEFAULT_PROFILE,
      pb: null,
      setProfile: (patch) =>
        set((s) => ({ profile: { ...s.profile, ...patch } })),
      setPb: (pb) => set({ pb }),
      reset: () =>
        set({
          profile: { ...DEFAULT_PROFILE, mmr: MMR_START, mmrSolo: MMR_START, mmrDuo: MMR_START },
          pb: null,
        }),
    }),
    { name: 'cd:user' }
  )
);
